export default __webpack_public_path__ + "static/media/MZGK_Boleslawiec.bb289c42.png";